import { Pie } from "react-chartjs-2";
import { makeStyles } from "@mui/styles";
import _ from "lodash";
import BlockSkeleton from "../Skeleton/BlockSkeleton";
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.register(...registerables);
Chart.register(ChartDataLabels);

const useStyles = makeStyles({
  root: {
    height: "100%",
  },
});

const NoData = {
  id: "NoData",
  afterDraw: function (chart) {
    if (chart.data.datasets[0].data.includes(-1)) {
      let ctx = chart.ctx;
      let width = chart.width;
      let height = chart.height;

      ctx.save();
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.font = "20px Arial";
      ctx.fillStyle = "white";
      ctx.fillText("No data to display", width / 2, height / 2);
      ctx.restore();
    }
  },
};
Chart.register(NoData);

function PieChart({ data, title, loading }) {
  const classes = useStyles();

  data.datasets.forEach((dataset) => {
    if (dataset.data.every((el) => el === 0)) {
      dataset.backgroundColor = ["rgba(155,155,155,.8)"];
      dataset.hoverBackgroundColor = ["rgba(155,155,155,.6)"];
      dataset.data = [-1];
      data.labels = [""];
    }
  });

  return (
    <div className={classes.root}>
      {loading ? (
        <BlockSkeleton />
      ) : (
        <Pie
          data={data}
          options={{
            elements: {
              arc: {
                borderWidth: data.datasets[0].data[0] === -1 ? 0 : 4,
              },
            },
            maintainAspectRatio: false,
            plugins: {
              tooltip: {
                enabled: false,
              },
              datalabels: {
                display: false,
              },
              legend: {
                display: true,
                position: "bottom",
                labels: {
                  font: {
                    size: 16,
                    family: "Arial",
                  },
                  filter: (legendItem, data) => {
                    const label = legendItem.text;
                    const labelIndex = _.findIndex(
                      data.labels,
                      (labelName) => labelName === label
                    );
                    const val = data.datasets[0].data[labelIndex];

                    legendItem.text = `${legendItem.text} : ${val}`;
                    if (val > 0 && legendItem.text !== " : 1") {
                      return true;
                    }
                    return false;
                  },
                },
              },
              title: {
                display: true,
                text: title,
                color: "#58595b",
                font: {
                  size: 16,
                  family: "Arial",
                },
              },
            },
          }}
        />
      )}
    </div>
  );
}

export default PieChart;
